import { type StateSlug, ForSaleCategory } from 'Types/enquiryStates';

type CalculateShouldVehicleShowOriginalPriceParams = {
	isBinDiscountVisibilityEnabled: boolean;
	isLiveSaleDiscountVisibilityEnabled: boolean;
	slug: StateSlug;
	vehicleOriginalPrice: string;
};

export const calculateShouldVehicleShowOriginalPrice = ({
	isBinDiscountVisibilityEnabled,
	isLiveSaleDiscountVisibilityEnabled,
	slug,
	vehicleOriginalPrice,
}: CalculateShouldVehicleShowOriginalPriceParams) => {
	const shouldShowBinOriginalPrice = slug === ForSaleCategory.forSale && isBinDiscountVisibilityEnabled;
	const shouldShowLiveSaleOriginalPrice = slug === ForSaleCategory.saleActive && isLiveSaleDiscountVisibilityEnabled;

	return Boolean(vehicleOriginalPrice && (shouldShowBinOriginalPrice || shouldShowLiveSaleOriginalPrice));
};
